export default function SoldStamp({ big = false }) {
  return (
    <div className="absolute inset-0 bg-black/35 flex items-center justify-center pointer-events-none" data-testid={big ? "sold-stamp-big" : "sold-stamp"}>
      <span className={`-rotate-12 border-[3px] md:border-4 border-white bg-[var(--sell)] text-white font-display font-extrabold tracking-widest rounded-lg shadow-xl ${big ? "text-5xl md:text-7xl px-8 py-3" : "text-2xl md:text-3xl px-4 py-1"}`}>
        SOLD
      </span>
    </div>
  );
}
